const styles = {
  link: {
    textUnderlineOffset: "5px",
  },
  header: { fontSize: { xs: 20, md: 30 } },
  limitedTime: {
    backgroundColor: "transparent",
    color: "secondary.dark",
  },
};

export default styles;
